export default "__VITE_ASSET__DSWSS9iq__"